export default __webpack_public_path__ + "static/Asia-4e33845df58620332a07745abddffd02.png";